import axios from "axios";
axios.defaults.withCredentials = true;
let API;
if (process.env.NODE_ENV === "production") {
    API = axios.create({
        baseURL: `${process.env.REACT_APP_PRODUCTION_API_URL}/api/v1`
    });
} else {
    API = axios.create({
        baseURL: `${process.env.REACT_APP_DEVELOPMENT_API_URL}/api/v1`
    });
}

console.log('Production API URL:', process.env.REACT_APP_PRODUCTION_API_URL);
console.log('Development API URL:', process.env.REACT_APP_DEVELOPMENT_API_URL);

// Auth
export const createCodeRegister = formData => API.post("/auth/code_register", formData);
export const createCode = formData => API.post("/auth/code", formData);
export const checkCode = formData => API.post("/auth/code/check", formData);
export const auth = () => API.get("/auth");
export const logout = () => API.get("/auth/logout");
export const login = formData => API.post(`/auth/login`, formData);
export const register = formData => API.post("/auth/signup", formData);
export const googleLogin = formData => API.post(`/auth/google_login`, formData);
export const updateUser = formData => API.put("/user/update", formData);

// Education
// export const educationList = role => API.get(`/${role}/education`).then(( res, error)=>{
//     if(res.data['status'] === 'UnSuccess'){
//         localStorage.clear();
//     }else{
//         return res;
//     }
// })

export const createEducation = (role, formData) => API.post(`/${role}/education`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const editEducation = (role, formData) => API.post(`/${role}/edit_education`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const removeEducation = formData => API.delete("/education", formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchEducation = (role, id) => API.get(`/${role}/education/${id}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Exam
export const addExam = (role, formData) => API.post(`/${role}/exam`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const editExam = (role, formData) => API.put(`/${role}/exam`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchExams = role => API.get(`/${role}/exam`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchExamLog = role => API.get(`/${role}/exam_log`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchUniqeExamLog = (role ,examId) => API.get(`/${role}/exam_log/${examId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchDetailUniqeExamLog = (role, examId , userId) => API.get(`/${role}/exam_log/detail/${examId}/${userId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchExam = (role , examId) => API.get(`/${role}/exam/${examId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const submitExam = (role , formData) => API.post(`/${role}/exam`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Ticket
export const fetchTickets = role => API.get(`/${role}/ticket`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const createTicket = (role, formData) => API.post(`/${role}/ticket`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchReplies = (role, ticketId) => API.get(`/${role}/ticket/${ticketId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const sendMessage = (role, ticketId, formData) => API.post(`/${role}/ticket/${ticketId}`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const updateStatus = (role, ticketId, formData) => API.put(`/${role}/ticket/${ticketId}`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const buyToken = (role, amount) => API.post(`/${role}/payment`, amount).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const checkPayment = (role, authority) => API.post(`/${role}/payment/check`, authority).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Blog
export const fetchBlogs = limit => API.get(`/blog${limit ? `?limit=${limit}` : ""}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const createBlog = (role, formData) => API.post(`/${role}/blog`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchSingleBlog = blogId => API.get(`/blog/${blogId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const removeBlog = blogId => API.delete(`/blog/${blogId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Category
export const fetchAllCategories = role => API.get(`/${role}/category`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const addCategroy = (role, formData) => API.post(`/${role}/category`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

export const removeCategory = (role, categoryId) => API.delete(`/${role}/category/${categoryId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Admin Dashboard
export const adminDashboard = () => API.get("/admin/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})


// Creator Dashboard
export const creatorDashboard = () => API.get("/creator/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Organization Dashboard
export const organizationDashboard = () => API.get("/organization/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// Teacher Dashboard
export const teacherDashboard = () => API.get("/teacher/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})


// Sub_Organization Dashboard
export const sub_organizationDashboard = () => API.get("/sub_organization/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// User_Organization Dashboard
export const user_organizationDashboard = () => API.get("/user_organization/").then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

// upload file
export const uploadFile = formData => API.post("/admin/upload", formData);


//license
export const fetchLicenses = (role) => API.get(`/${role}/certificate`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

//Requests
export const fetchRequests = role => API.get(`/${role}/request`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const createRequest = (role, formData) => API.post(`/${role}/request`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const fetchRepliesRequest = (role, requestId) => API.get(`/${role}/request/${requestId}`).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const sendMessageRequest = (role, requestId, formData) => API.post(`/${role}/request/${requestId}`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})
export const updateStatusRequest = (requestId, formData) => API.put(`/admin/request/${requestId}`, formData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})

export const VerifyRequest = (requestId, verifyData) => API.post(`/admin/request/${requestId}`, verifyData).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})


//Money
export const decrementMoney = (role ,amount ) => API.post(`/${role}/wallet/decrement`, amount).then(( res, error)=>{
    if(res.data['status'] === 'UnSuccess'){
        localStorage.clear();
    }else{
        return res;
    }
})



